import { Color } from "three";
import { MathUtils } from "@utils/MathUtils";

export const minTime = 0;
export const maxTime = 48;

/* eslint-disable @typescript-eslint/no-unused-vars */
const timeNoon1 = -3;
const timeEvening1 = 6;
const timeNight1 = 9;
const timeNight2 = 13;
const timeMorning = 16;
const timeNoon2 = 21;
const timeEvening2 = 30;
const timeNight3 = 33;
const timeNight4 = 37;
/* eslint-enable @typescript-eslint/no-unused-vars */

export function closestNeutral(time: number): number {
    if (time < 12) return 0;
    return 24;
}

export function mapTime(time: number, from: number, to: number): number {
    return MathUtils.mapRange(time, minTime, maxTime, from, to);
}

export function timeToValue(time: number, noon: number, evening: number, night: number): number {
    if (time < timeEvening1) return MathUtils.lerp(noon, evening, MathUtils.mapRange(time, timeNoon1, timeEvening1, 0, 1));
    else if (time < timeNight1) return MathUtils.lerp(evening, night, MathUtils.mapRange(time, timeEvening1, timeNight1, 0, 1));
    else if (time < timeNight2) return night;
    else if (time < timeMorning) return MathUtils.lerp(night, evening, MathUtils.mapRange(time, timeNight2, timeMorning, 0, 1));
    else if (time < timeNoon2) return MathUtils.lerp(evening, noon, MathUtils.mapRange(time, timeMorning, timeNoon2, 0, 1));
    else if (time < timeEvening2) return MathUtils.lerp(noon, evening, MathUtils.mapRange(time, timeNoon2, timeEvening2, 0, 1));
    else if (time < timeNight3) return MathUtils.lerp(evening, night, MathUtils.mapRange(time, timeEvening2, timeNight3, 0, 1));
    else return night;
}


export function timeToColor(color: Color, time: number, noon: Color, evening: Color, night: Color) {
    if (time < timeEvening1) color.lerpColors(noon, evening, MathUtils.mapRange(time, timeNoon1, timeEvening1, 0, 1));
    else if (time < timeNight1) color.lerpColors(evening, night, MathUtils.mapRange(time, timeEvening1, timeNight1, 0, 1));
    else if (time < timeNight2) color.copy(night);
    else if (time < timeMorning) color.lerpColors(night, evening, MathUtils.mapRange(time, timeNight2, timeMorning, 0, 1));
    else if (time < timeNoon2) color.lerpColors(evening, noon, MathUtils.mapRange(time, timeMorning, timeNoon2, 0, 1));
    else if (time < timeEvening2) color.lerpColors(noon, evening, MathUtils.mapRange(time, timeNoon2, timeEvening2, 0, 1));
    else if (time < timeNight3) color.lerpColors(evening, night, MathUtils.mapRange(time, timeEvening2, timeNight3, 0, 1));
    else color.copy(night);
} 